import {
  createMissionControlEstablishedAhpBootstrap,
  type MissionControlEstablishedAhpBootstrapOptions,
} from '@github-ui/agent-sessions/ahp/established-ahp-bootstrap'
import type {EstablishedAhpSessionBootstrap} from '@github-ui/ahp-session-client/contracts'

export type QuickChatEstablishedAhpBootstrapOptions = MissionControlEstablishedAhpBootstrapOptions

/**
 * Quick Chat owns task/session provisioning and route adapters, while the
 * established runtime is shared with Mission Control after this boundary.
 */
export function createQuickChatEstablishedAhpBootstrap(
  options: QuickChatEstablishedAhpBootstrapOptions,
): EstablishedAhpSessionBootstrap {
  return createMissionControlEstablishedAhpBootstrap(options)
}
